import {useQuery} from '@tanstack/react-query'
import {SubscriptionDetailsType} from 'interfaces'
import {EndpointsService, SettingsService} from 'services/api'

export const SUBSCRIPTION_DETAILS_QUERY_KEY = 'getSubscriptionDetails'
export const useSubscriptionDetailsQuery = () => {
  return useQuery({
    queryKey: [SUBSCRIPTION_DETAILS_QUERY_KEY],
    queryFn: subscriptionDetailsQueryFunction,
    initialData: {} as SubscriptionDetailsType,
  })
}
export const subscriptionDetailsQueryFunction =
  async (): Promise<SubscriptionDetailsType> => {
    try {
      const [{data: subscriptionRes}, {data: epAggregationRes}] =
        await Promise.all([
          SettingsService.getSubscriptionDetails(),
          EndpointsService.getEndpointMetaData(),
        ])
      const subData = subscriptionRes
      const epAggData = epAggregationRes
      const finalSubData = {
        ...subData,
        // typecast license value to string
        numberOfActiveLicenses: String(epAggData?.totalLicense),
      }

      return finalSubData
    } catch (error) {
      // rejected promise with error
      return Promise.reject(error)
    }
  }
